import clsx from 'clsx'
import { type HTMLMotionProps, motion } from 'motion/react'
import { type HTMLAttributes, type Ref } from 'react'
import styles from './ScanQRCodeTutorial.module.css'

export interface ScanQRCodeTutorialProps
	extends
		Omit<HTMLAttributes<HTMLDivElement>, keyof HTMLMotionProps<'div'>>,
		HTMLMotionProps<'div'> {
	ref?: Ref<HTMLDivElement>
}

interface AnimatedImageProps {
	src: string
	initialPosition: {
		y: number
		x: number
	}
	animatePosition: {
		y: number
		rotate: string
	}
	delay: number
}

// 处理单个动画图片的子组件
function AnimatedImage({ src, initialPosition, animatePosition, delay }: AnimatedImageProps) {
	return (
		<motion.img
			src={src}
			className={styles.image}
			initial={{
				opacity: 0,
				...initialPosition,
			}}
			animate={{
				opacity: 1,
				...animatePosition,
				transition: {
					delay,
					type: 'spring',
					duration: 1,
				},
			}}
		/>
	)
}

export default function ScanQRCodeTutorial({ ref, className, ...props }: ScanQRCodeTutorialProps) {
	return (
		<motion.div ref={ref} className={clsx(styles.container, className)} {...props}>
			<AnimatedImage
				src="https://cdnv2.ruguoapp.com/FqWRam4o2IY5XaCjYF5LZJqEfVJI.jpeg"
				initialPosition={{ y: -100, x: 40 }}
				animatePosition={{ y: -60, rotate: '-10deg' }}
				delay={0.3}
			/>
			<AnimatedImage
				src="https://cdnv2.ruguoapp.com/FiOi_lJazChl4V1xwf_f1C72YbGR.jpeg"
				initialPosition={{ y: 100, x: -40 }}
				animatePosition={{ y: 60, rotate: '10deg' }}
				delay={1.3}
			/>
		</motion.div>
	)
}
